import BaseIcon from './BaseIcon';
import React, { ReactElement, SVGProps } from 'react'

export default function ShareIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="m21.398 10.147-4.5 4.5a.563.563 0 0 1-.795-.795l3.54-3.54h-4.175a8.431 8.431 0 0 0-8.172 6.329.563.563 0 1 1-1.089-.282 9.556 9.556 0 0 1 9.262-7.171h4.175l-3.542-3.54a.563.563 0 0 1 .795-.795l4.5 4.5a.563.563 0 0 1 0 .795ZM18 19.688H3.75a.188.188 0 0 1-.187-.188V8.25a.563.563 0 0 0-1.125 0V19.5a1.313 1.313 0 0 0 1.313 1.313H18a.563.563 0 0 0 0-1.125Z"
        fill="currentColor" />
    </BaseIcon>
  )
}
